"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_OFFER_CHANGE_APPROVAL = void 0;
exports.GET_OFFER_CHANGE_APPROVAL = {
    TRAVEL_NOT_FOUND: {
        usecase: 'GET_OFFER_CHANGE_APPROVAL',
        type: 'TRAVEL_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Viagem não encontrada.',
            'EN-US': 'Travel not found.',
        },
    },
    OFFER_NOT_FOUND: {
        usecase: 'GET_OFFER_CHANGE_APPROVAL',
        type: 'OFFER_NOT_FOUND',
        messageLangMap: {
            'PT-BR': 'Oferta não encontrada.',
            'EN-US': 'Offer not found.',
        },
    },
};
